'use client'

import { PaginatedCollaborationOpening } from '@/backend/models/CollaborationOpening'
import Link from 'next/link'
// import { useMediaQuery } from 'react-responsive'
import { useCurrentLocale } from '@/locales/client'

import OpenCollaboCard from '@/app/_components/Collabo/OpenCollaboCard'
import ArrowDown from '@/app/_components/Icon/ArrowDown'
import {
  default as I18nTranslator,
  default as I18nTranslatorClient,
} from '@/app/_components/Shared/I18nTranslator/I18nTranslatorClient'
import { useGetCollaborations } from '@/app/_hooks/useGetCollaborations'
import { SubHeader } from '@/app/_primitives/SubHeader'
import '@/app/initialize'
import { cn } from '@/app/utils'

function useLimit() {
  // const is2xl = useMediaQuery({
  //   query: '(min-width: 1440px)',
  // })
  // const isXl = useMediaQuery({
  //   query: '(min-width: 1024px)',
  // })

  // if (typeof window === 'undefined') return 4

  return 20
}

export default function HighlightCollabo({
  initialData,
  isLoggedIn,
}: {
  initialData: PaginatedCollaborationOpening
  isLoggedIn?: boolean
}) {
  const limit = useLimit()
  const data = initialData.data

  const { items, hasNextPage, isFetchingNextPage, fetchNextPage } =
    useGetCollaborations({
      initialData: initialData.data,
      limit,
      type: 'highlighted',
    })
  return (
    <div className="container relative pb-120 pt-0 max-lg:pt-20">
      <div className="a-h2 text-48 leading-[140%] text-french-bleu">
        ❣️ Collabo
      </div>
      <SubHeader
        className={'relative mb-34 mt-19 w-full'}
        variant={'dark'}
        customLink={
          <div className="flex items-center gap-8 max-lg:hidden">
            <div className="c-b2 font-[400] leading-[140%] text-[#B4B4B4]">
              {<I18nTranslator text="common.highlightCollaboLabel1" />}
            </div>

            <div className="c-h6 text-french-bleu underline underline-offset-4">
              <Link href={'/collabo/create'}>
                {<I18nTranslator text="common.collaboRegist" />}
              </Link>
            </div>
          </div>
        }>
        {/* {<I18nTranslator text="common.highlightCollabo" />} */}
        <div className="flex flex-wrap items-center">
          <span
            className={cn('flex items-center break-keep', {
              'c-h7 lg:c-h6': useCurrentLocale() === 'en',
            })}>
            <I18nTranslatorClient text="collabo_subText" /> &nbsp;
            {data.filter((v) => v.status === 'in-progress').length >= 1 && (
              <span className={'c-b3 text-[#8b8b8b] lg:c-b2'}>
                {data.filter((v) => v.status === 'in-progress').length}
                <I18nTranslatorClient text="common.collabo_count" />
              </span>
            )}
          </span>
        </div>
      </SubHeader>
      <div className="flex flex-col items-center">
        {/* FIXME */}
        <div className="relative grid gap-24 max-lg:flex max-lg:w-full max-lg:flex-col lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
          {data
            .sort((a, b) => {
              return a.recommendedRank - b.recommendedRank
            })
            .map((collabo) => (
              <OpenCollaboCard
                key={collabo.id}
                collaboration={collabo}
                isLoggedIn={isLoggedIn!}
              />
            ))}
          {items.map((collabo) => (
            <OpenCollaboCard
              key={collabo.id}
              collaboration={collabo}
              isLoggedIn={isLoggedIn!}
            />
          ))}
        </div>
        {hasNextPage && (
          <button
            type="button"
            className="c-b2 mt-32 flex items-center gap-4"
            disabled={isFetchingNextPage}
            onClick={() => {
              if (hasNextPage && !isFetchingNextPage) return fetchNextPage()
            }}>
            <div className="text-french-bleu">
              {<I18nTranslator text={'common.viewMoreLabel'} />}
            </div>
            <ArrowDown width={24} height={24} fill="#3366B6" />
          </button>
        )}
      </div>
    </div>
  )
}
